/**
 * Gesundheitsportal - Online Appointments REST API
 * Gesundheitsportal Online Appointments Service REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: valeriu.craciun@kronsoft.ro
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Waiting List Status Enum
 */
export type WaitingListStatusEnumDTO = 'PENDING' | 'CONFIRMED' | 'CANCELED' | 'PENDING_CANCELLATION' | 'BOOKED';

export const WaitingListStatusEnumDTO = {
    PENDING: 'PENDING' as WaitingListStatusEnumDTO,
    CONFIRMED: 'CONFIRMED' as WaitingListStatusEnumDTO,
    CANCELED: 'CANCELED' as WaitingListStatusEnumDTO,
    PENDINGCANCELLATION: 'PENDING_CANCELLATION' as WaitingListStatusEnumDTO,
    BOOKED: 'BOOKED' as WaitingListStatusEnumDTO
};

